export default __webpack_public_path__ + "static/media/goopter-use-case-casinos.4dfa5453.jpg";